// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1D4G_","title":"ClientInsurance_title__19oZo","itemText":"ClientInsurance_itemText__1WSVS"};